import {
  AutomatedCurationSort,
  HomepageCurationType,
} from '../../../redux-toolkits/home-page-v2.1/homePageV21.type'

type ProductSection = HomepageCurationType['productSection']

export const sortLabels: Record<AutomatedCurationSort, string> = {
  newest: 'Newest',
  price_low: 'Price: low to high',
  price_high: 'Price: high to low',
  sales_volume: 'Best sellers',
  event_date: 'Soonest first',
}

const isSortAllowed = (
  sort: AutomatedCurationSort,
  productSection?: ProductSection,
) => sort !== 'event_date' || productSection === 'EVENT'

export const getSortOptions = (productSection?: ProductSection) =>
  (Object.keys(sortLabels) as AutomatedCurationSort[])
    .filter((sort) => isSortAllowed(sort, productSection))
    .map((sort) => ({ value: sort, label: sortLabels[sort] }))

// Falls back to newest when a sort is not offered for the curation type.
export const sortForSection = (
  sort: AutomatedCurationSort | undefined,
  productSection?: ProductSection,
): AutomatedCurationSort =>
  sort && isSortAllowed(sort, productSection) ? sort : 'newest'

export const automatedSourceLabel = ({
  sort,
  salesLookbackDays,
  productSection,
}: {
  sort: AutomatedCurationSort
  salesLookbackDays: number
  productSection?: ProductSection
}) => {
  // Events curation excludes past events instead of using an upload window.
  const isEvents = productSection === 'EVENT'
  if (sort === 'sales_volume') {
    const salesLabel = `Sales from the last ${salesLookbackDays} days`
    return isEvents ? `Upcoming events · ${salesLabel}` : salesLabel
  }
  return isEvents ? 'Upcoming events' : 'Uploaded in the last 30 days'
}
